import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../../LocalStorageKeys';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  setItem(key: LocalStorageKeys, value: string) {
    localStorage?.setItem(key, value);
  }

  getItem(key: LocalStorageKeys) {
    return localStorage?.getItem(key);
  }

  removeItem(key: LocalStorageKeys) {
    localStorage?.removeItem(key);
  }

  clear() {
    localStorage?.clear();
  }

  isDefined() {
    return !!localStorage;
  }
}
